import React, { Fragment } from 'react';
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import ReactMenu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import ListItemText from '@mui/material/ListItemText';
import { logout } from '../../../store/actions/system/UserActions';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import MenuNavLink from './MenuNavLink';
import Avatar from '@mui/material/Avatar';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import GroupWorkIcon from '@mui/icons-material/GroupWork';
import PaymentIcon from '@mui/icons-material/Payment';
import { getPXLProfileRoute } from '../../../router/routes/pxl/factory/profile';
import { getPXLWorkGroupRoute } from '../../../router/routes/pxl/factory/workGroup';
import { getPXLContactRoute } from '../../../router/routes/pxl/factory/general';
import { getPXLBillingsRoute, getPXLOrdersRoute } from '../../../router/routes/pxl/factory/order';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { getArtistWizardRoute } from '../../../router/routes/artist/factory/wizard';
import { PersonAdd } from '@mui/icons-material';
import { useHistory } from '../../utils/reactRouterCompatibility';

const ProfileAvatar = styled(Avatar)(({ theme }) => ({
  cursor: 'pointer',
  marginRight: theme.spacing(3)
}));

const CenteredDiv = styled('div')({
  textAlign: 'center'
});

const ProfileMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const open = Boolean(anchorEl);
  const { t } = useTranslation();
  
  // Use selector hooks instead of connect
  const user = useSelector(state => state.user.user);
  const selectedRealm = useSelector(state => state.realm.selected);

  const handleMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    setAnchorEl(null);
    dispatch(logout());
  };

  return (
    <Fragment>
      <ProfileAvatar 
        onClick={handleMenu}
        src={user.Profile.Media_Image ? user.Profile.Media_Image.Url : ''}
      />

      <ReactMenu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        open={open}
        onClose={handleClose}
      >
        <CenteredDiv>
          <Typography variant="subtitle1">
            {user.Profile.Display_Name}
          </Typography>
        </CenteredDiv>

        <div>
          <MenuNavLink
            onClick={handleClose}
            tooltip={t('menu_profile')}
            path={getPXLProfileRoute()}
            exact={true}
            icon={<AccountCircle/>}
            primary={t('menu_profile')}
          />
        </div>
        <div>
          <MenuNavLink
            onClick={handleClose}
            tooltip={t('menu_my_orders')}
            path={getPXLOrdersRoute()}
            exact={true}
            icon={<PaymentIcon/>}
            primary={t('menu_my_orders')}
          />
        </div>
        <div>
          <MenuNavLink
            onClick={handleClose}
            tooltip={t('menu_billings')}
            path={getPXLBillingsRoute()}
            exact={true}
            icon={<AccountBalanceWalletIcon/>}
            primary={t('menu_billings')}
          />
        </div>
        <div>
          <MenuNavLink
            disabled={!selectedRealm}
            onClick={handleClose}
            tooltip={t('menu_work_group')}
            path={getPXLWorkGroupRoute()}
            exact={true}
            icon={<GroupWorkIcon/>}
            primary={t('menu_work_group')}
          />
        </div>
        <div>
          <MenuItem onClick={() => {
            history.push(getArtistWizardRoute());
            handleClose();
          }}>
            <ListItemIcon>
              <PersonAdd/>
            </ListItemIcon>
            <ListItemText primary={t('menu_artist_wizard')}/>
          </MenuItem>
        </div>
        <div>
          <MenuNavLink
            onClick={handleClose}
            tooltip={t('menu_contact_us')}
            path={getPXLContactRoute()}
            exact={true}
            icon={<ContactSupportIcon/>}
            primary={t('menu_contact_us')}
          />
        </div>
        <MenuItem onClick={handleLogout}>
          <ListItemIcon>
            <LogoutIcon fontSize="small"/>
          </ListItemIcon>
          <ListItemText primary={t('menu_logout')}/>
        </MenuItem>
      </ReactMenu>
    </Fragment>
  );
};

export default ProfileMenu;